import { render } from "./GlobalContextMenu.vue?vue&type=template&id=2358c453&scoped=true&ts=true"
import script from "./GlobalContextMenu.vue?vue&type=script&lang=ts"
export * from "./GlobalContextMenu.vue?vue&type=script&lang=ts"

import "./GlobalContextMenu.vue?vue&type=style&index=0&id=2358c453&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2358c453"]])

export default __exports__